import { createSlice, PayloadAction } from '@reduxjs/toolkit'

const initialState: ModalState = {
    content: null,
    show: false,
}

export const ModalSlice = createSlice({
    name: 'modalSlice',
    initialState,
    reducers: {
        showModal: (state) => {
            state.show = true
        },
        hideModal: (state) => {
            state.show = false
        },
        setModalContent: (
            state,
            action: PayloadAction<JSX.Element | JSX.Element[]>
        ) => {
            state.content = action.payload
        },
    },
})

export const { hideModal, setModalContent, showModal } = ModalSlice.actions
export default ModalSlice.reducer
